import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AdminHeader from './AdminHeader'
import AdminSideBar from './AdminSideBar'
import AdminFooter from './AdminFooter'
import { useUser } from '../../context/UserContext'
import PageWrapper from './PageWrapper'
import Logo from "../../assets/image/logo/logowhite.png";

const AdminMain = () => {
    const user = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if(!user?.isAdmin){
            navigate('/')
        }
    },[])

  return (
    <div className='flex  '  >
        <div className=' h-[100vh] bg-[#011539] ' >
            <div className='py-[20px] px-[20px]' >
                <img src={Logo} width={100} />
            </div>
        <AdminSideBar />
        </div>
        <div  className='flex-1' >
        <AdminHeader />
        <PageWrapper >
        <Outlet />
        </PageWrapper>
        </div>
    </div>
    // <div>
    //     <AdminHeader />
    //     <br/>
    //     <div className='flex gap-2 mt-[50px]  ' >
    //         <AdminSideBar />
    //         <PageWrapper >
    //             <Outlet />
    //         </PageWrapper>
    //     </div>
    //     <AdminFooter />
    // </div>
  )
}

export default AdminMain